import SearchBarStore from 'hljd/esm/SearchBar/store'
import Api from '../api'
import { Modal, message } from 'hljd'
import { observable } from 'mobx'
import { goNewWcd } from '../util'

class Store extends SearchBarStore {
  $listApi = Api.activityList
  // 在这个数组中的 name 字段改变时不会直接触发请求
  $noNeed = ['name']
  $pageSizeKey = 'perPage'
  @observable showTemplateModal = false

  /**
   * 获取列表前的获取参数方法
   * return 值为请求参数
   */
  $getParams = () => {
    const { time, ...rest } = this.$params

    return {
      ...rest,
      startDate: this.$paramsUtil.getRangeStart(time),
      endDate: this.$paramsUtil.getRangeEnd(time)
    }
  }

  /**
   * 获取列表后的额外操作
   */
  $extraOp = data => {}

  delActivity = async id => {
    Modal.confirm({
      title: '确定删除该活动吗？',
      onOk: () => {
        return new Promise(async (resolve, reject) => {
          const { success } = await Api.delActivity({ id })

          if (success) {
            message.success('删除成功')
            this.$getList()
          }

          resolve()
        })
      }
    })
  }

  createActivity = () => {
    this.showTemplateModal = true
  }

  closeTemplateModal = () => {
    this.showTemplateModal = false
  }

  handleCreateActivity = (data = {}) => {
    goNewWcd(data.id)
    this.closeTemplateModal()
  }
}

export default Store
